export default "__VITE_ASSET__cDksSzDH__"